/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EVMChain,
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    NftSaleConfigLineItem,
    NftSaleConfigLineItemFromJSON,
    NftSaleConfigLineItemFromJSONTyped,
    NftSaleConfigLineItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface NftPurchaseTransaction
 */
export interface NftPurchaseTransaction extends NftSaleConfigLineItem {
    /**
     * 
     * @type {string}
     * @memberof NftPurchaseTransaction
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchaseTransaction
     */
    nftMintTransaction?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchaseTransaction
     */
    contractAddress?: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof NftPurchaseTransaction
     */
    chain?: EVMChain;
    /**
     * 
     * @type {Array<string>}
     * @memberof NftPurchaseTransaction
     */
    nftOwnerships?: Array<string>;
}

export function NftPurchaseTransactionFromJSON(json: any): NftPurchaseTransaction {
    return NftPurchaseTransactionFromJSONTyped(json, false);
}

export function NftPurchaseTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftPurchaseTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...NftSaleConfigLineItemFromJSONTyped(json, ignoreDiscriminator),
        'transactionHash': !exists(json, 'transactionHash') ? undefined : json['transactionHash'],
        'nftMintTransaction': !exists(json, 'nftMintTransaction') ? undefined : json['nftMintTransaction'],
        'contractAddress': !exists(json, 'contractAddress') ? undefined : json['contractAddress'],
        'chain': !exists(json, 'chain') ? undefined : EVMChainFromJSON(json['chain']),
        'nftOwnerships': !exists(json, 'nftOwnerships') ? undefined : json['nftOwnerships'],
    };
}

export function NftPurchaseTransactionToJSON(value?: NftPurchaseTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...NftSaleConfigLineItemToJSON(value),
        'transactionHash': value.transactionHash,
        'nftMintTransaction': value.nftMintTransaction,
        'contractAddress': value.contractAddress,
        'chain': EVMChainToJSON(value.chain),
        'nftOwnerships': value.nftOwnerships,
    };
}


